module.exports = __webpack_public_path__ + "static/media/routes14.ac25a07d.webp";